import {createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import axios from "axios";
import {instance, pathname} from "./ActionCreators";

export type ITable = {
    id: number
    columns: string
    params: Array<object>
}

export interface IPage {
    id: number,
    name: string,
    grid: string
    tables: Array<ITable>
    sections: any
}

interface IState {
    loading: boolean
    error: string | null
    pages: Array<IPage>
    activePage: IPage | null
}

const initialState: IState = {
    loading: false,
    error: null,
    pages: [],
    activePage: null,
}

export const getTabs = createAsyncThunk('get/tabs',
    async (_, {rejectWithValue}) => {
        try {
            const response = await instance.get(pathname + 'api/tab')
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message)
            }
        }
    }
)

export const getTabById = createAsyncThunk('get/tabs/id',
    async (id: number, {rejectWithValue, dispatch}) => {
        try {
            const response = await instance.get(pathname + `api/tab/${id}`)
            console.log({tab: response.data})
            dispatch(getAreasByTabId(id))
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message)
            }
        }
    }
)

export const getAreasByTabId = createAsyncThunk('get/areas',
    async (id: number, {rejectWithValue}) => {
        try {
            const response = await instance.get(pathname + `api/workspaces/${id}`)
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message)
            }
        }
    }
)
export const updateTab = createAsyncThunk('update/tab',
    async (data: object, {rejectWithValue, dispatch, getState}) => {
        try {
            //@ts-ignore
            const page = getState().quotesPage.activePage
            const obj = {
                ...data,
                name: page.name
            }
            const response = await instance.patch(pathname + `api/tab/${page.id}`, obj)
            //dispatch(getTabById(page.id))
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message)
            }
        }
    }
)

export const updateWorkspace = createAsyncThunk('fix/workspace',
    async ({data, tabId}: { data: object, tabId?: number }, {rejectWithValue, dispatch, getState}) => {
        try {
            //@ts-ignore
            const page = getState().quotesPage.activePage
            const response = await instance.patch(pathname + `api/workspace_config/${tabId || page.id}`, data)
            dispatch(getAreasByTabId(page.id))
            return response.data
        } catch (e) {
            if (axios.isAxiosError(e)) {
                return rejectWithValue(e.message)
            }
        }
    }
)

const quotesPageSlice = createSlice({
    name: 'quotesPageSlice',
    initialState,
    reducers: {
        resetQuotesPageState: () => {
            return initialState
        },
        setActivePage: (state, action: PayloadAction<number | null>) => {
            const page = {...state.pages.find(item => item.id === action.payload)}
            //@ts-ignore
            // state.activePage = page ?? null
            if (page?.id) {
                //@ts-ignore
                state.activePage = page
            } else if (action.payload === null) {
                state.activePage = null
            }
        },
        setActivePageName: (state, action: PayloadAction<string>) => {
            if (state.activePage) {
                // console.log(state.activePage,action.payload)
                state.activePage.name = action.payload
            }

        },

        reorder: (state, action: PayloadAction<{ source: number, destination: number }>) => {
            if (!state.activePage) return
            const {source, destination} = action.payload
            const [removed] = state.activePage.tables.splice(source, 1);
            state.activePage.tables.splice(destination, 0, removed);
        }
    },
    extraReducers: {
        [getTabs.fulfilled.type]: (state, action) => {

            state.loading = false
            state.error = null
            state.pages = action.payload.map((item: any) => ({...item, tables: []}))
        },
        [getTabs.pending.type]: (state) => {
            state.loading = true
        },
        [getTabs.rejected.type]: (state, action) => {
            state.loading = false
            state.error = action.payload
        },
        [getTabById.fulfilled.type]: (state, action) => {
            state.loading = false
            state.error = null
            /*
            const addElements = (currentLen: number, necessaryLen: number) => Array.from({length: necessaryLen - currentLen}).map((_) => ({
                width: 100 / necessaryLen,
                height: 100 / necessaryLen
            }))

            //@ts-ignore
            const count = action.payload.grid.split('-').reduce((acum, item) => acum + +item, 0)
            const currentLenght = action.payload.sections.length
            const newSections = currentLenght > count ?
                action.payload.sections.slice(0, count)
                :
                currentLenght < count ? [...action.payload.sections, ...addElements(currentLenght, count)] : action.payload.sections
            // console.log("state.activePage = obj", obj)
            console.log('getTabById.fulfilled.type', newSections, action.payload.sections);
            */
            state.activePage = {...action.payload, sections: action.payload.sections}
        },
    }
});

export const {setActivePage, setActivePageName, reorder, resetQuotesPageState} = quotesPageSlice.actions

export default quotesPageSlice.reducer
